import styled, { css } from 'styled-components';
import { useAccessibilityContext } from 'conversations-visitor-message-history/accessibility/AccessibilityContext';
import { useRef } from 'react';
import { useOverlay } from '@react-aria/overlays';
import { useDialog } from '@react-aria/dialog';
import { CSSTransition } from 'react-transition-group';
import { HEADER_TEXT_DESCRIPTION_ID, HEADER_TEXT_TITLE_ID } from 'conversations-visitor-experience-components/visitor-widget/constants/textIds';
import { RIGHT_ALIGNED } from 'conversations-internal-schema/widget-location/constants/WidgetLocations';
import { SIDE_DOCK_WIDTH, ANIMATION_DURATION } from '../constants/sideDockConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const rightAlignedStyles = css(["right:0;&.side-dock-enter{transform:translateX(100%);}&.side-dock-enter-active{transform:translateX(0);}&.side-dock-exit{transform:translateX(0);}&.side-dock-exit-active{transform:translateX(100%);}"]);
const leftAlignedStyles = css(["left:0;&.side-dock-enter{transform:translateX(-100%);}&.side-dock-enter-active{transform:translateX(0);}&.side-dock-exit{transform:translateX(0);}&.side-dock-exit-active{transform:translateX(-100%);}"]);

// TODO: bkopp consider using the cubic-bezier function for the transition
const Main = styled.div.withConfig({
  displayName: "SideDockDialogWindow__Main"
})(["position:fixed;top:0;height:100%;width:", "px;max-width:100vw;display:flex;flex-direction:column;z-index:2147483647;&:focus{outline:none;}&.side-dock-enter-active,&.side-dock-exit-active{transition:transform ", "ms linear;}", ""], SIDE_DOCK_WIDTH, ANIMATION_DURATION, ({
  $widgetLocation
}) => $widgetLocation === RIGHT_ALIGNED ? rightAlignedStyles : leftAlignedStyles);
const SideDockDialogWindow = props => {
  const {
    isOpen,
    onClose,
    children,
    onEnter,
    onEntered,
    onExit,
    onExited,
    widgetLocation = RIGHT_ALIGNED
  } = props;
  const ref = useRef(null);
  const {
    dialogProps
  } = useDialog({
    id: 'side-dock-panel',
    'aria-labelledby': HEADER_TEXT_TITLE_ID,
    'aria-describedby': HEADER_TEXT_DESCRIPTION_ID
  },
  // TODO: remove cast when on React 19 types (HubSpotEngineering/fefw#73)
  ref);
  const {
    disableWidgetClose,
    launcherRef,
    setShouldTrapFocus
  } = useAccessibilityContext();
  const disableFocusTrapOnInteractOutside = element => {
    const isLauncherButton = (element === null || element === void 0 ? void 0 : element.tagName) === 'BUTTON';
    if (!isLauncherButton) {
      setShouldTrapFocus(false);
    }
    return false;
  };
  const {
    overlayProps
  } = useOverlay({
    isOpen,
    isKeyboardDismissDisabled: disableWidgetClose,
    onClose: () => {
      if (onClose) onClose();
      if (launcherRef) {
        launcherRef.focus();
      }
    },
    shouldCloseOnBlur: true,
    shouldCloseOnInteractOutside: disableFocusTrapOnInteractOutside
  },
  // TODO: remove cast when on React 19 types (HubSpotEngineering/fefw#73)
  ref);
  return /*#__PURE__*/_jsx(CSSTransition, {
    in: isOpen,
    timeout: ANIMATION_DURATION,
    classNames: "side-dock",
    nodeRef: ref,
    mountOnEnter: true,
    unmountOnExit: true,
    onEnter: onEnter,
    onEntered: onEntered,
    onExit: onExit,
    onExited: onExited,
    children: /*#__PURE__*/_jsx(Main, Object.assign({
      ref: ref,
      $widgetLocation: widgetLocation,
      "data-test-id": "side-dock-dialog",
      "data-widget-location": widgetLocation
    }, overlayProps, dialogProps, {
      onClick: () => setShouldTrapFocus(true),
      children: children
    }))
  });
};
SideDockDialogWindow.displayName = 'SideDockDialogWindow';
export default SideDockDialogWindow;